import React, { useState } from 'react';

let timeout;

export default function Search({ filterTable, additionalClasses = '' }) {
    const [value, setValue] = useState('');

    function handleChange(event) {
        if (timeout) clearTimeout(timeout);
        const currentValue = event.target.value;
        setValue(currentValue);
        timeout = setTimeout(() => {
            filterTable(currentValue);
        }, 1000);
    }

    return (
        <div className={`search-container mr-3 ${additionalClasses}`}>
            <i className="fa fa-search search-icon" />
            <input
                className="form-control form-control search-box"
                type="search"
                name="search"
                placeholder="enter keyword to search"
                value={value}
                onChange={handleChange}
            />
        </div>
    );
}
